import { render, staticRenderFns } from "./NoNote.vue?vue&type=template&id=6588a1ee&scoped=true&"
import script from "./NoNote.vue?vue&type=script&lang=js&"
export * from "./NoNote.vue?vue&type=script&lang=js&"
import style0 from "./NoNote.vue?vue&type=style&index=0&id=6588a1ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6588a1ee",
  null
  
)

export default component.exports